module.exports = __webpack_public_path__ + "static/media/image-card-7.9fe7c496.png";